import module from 'finanzas/module.js'

module.config(($stateProvider) => {
  $stateProvider.state('finances.posicionbancaria.movimientos', {
    url: '/saldos?{fecha_corte:date}&{estatus_cuenta}',
    reloadOnSearch: true,
    data: {title: 'Posición Bancaria'},
    template: '<finances-posicionbancaria-saldos fecha-corte="fechaCorte" estatus-cuenta="estatusCuenta"></finances-posicionbancaria-saldos>',
    controller ($scope, $stateParams) {
      $scope.fechaCorte = $stateParams.fecha_corte
      $scope.estatusCuenta = $stateParams.estatus_cuenta
    },
  })
})



// WEBPACK FOOTER //
// ./src/finanzas/routes/finances/posicionbancaria/saldos.js